"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const sortablejs_1 = __importDefault(require("sortablejs"));
const makeMyClasses = dragging => ({
    root: {
        '& .sortable-ghost': {
            borderTop: `2px solid ${lib_palette_1.default.primary.main}`,
            borderBottom: `2px solid ${lib_palette_1.default.primary.main}`,
            borderRadius: 4,
        },
        '& .sortable-drag': {
            color: lib_palette_1.default.primary.main,
            '& .delete': { display: 'none' },
        },
        '& .MuiTab-wrapper': {
            color: dragging ? lib_palette_1.default.BlackCoral.main : 'inherit',
        },
        '& .delete': {
            display: dragging ? 'none' : 'block',
        },
        '& .dragHandle': {
            display: dragging ? 'none' : 'block',
        },
        '& .MuiTabs-indicator': {
            display: dragging ? 'none' : 'block',
        },
    },
});
exports.Tabs = react_1.default.memo((props) => {
    const { onReorder, value, onChange, children } = props, otherProps = __rest(props, ["onReorder", "value", "onChange", "children"]);
    const [localValue, setLocalValue] = (0, react_1.useState)(value);
    (0, react_1.useEffect)(() => {
        setLocalValue(value);
    }, [value]);
    const handleChange = (0, react_1.useCallback)((e, v) => {
        setLocalValue(v);
        setTimeout(() => onChange === null || onChange === void 0 ? void 0 : onChange(e, v), 0);
    }, [onChange]);
    const RootComponent = !!onReorder ? SortableTabsComponent(onReorder) : undefined;
    return (react_1.default.createElement(Tabs_1.default, Object.assign({ component: RootComponent }, otherProps, { value: localValue, onChange: handleChange }), children));
});
exports.default = exports.Tabs;
const SortableTabsComponent = onReorder => ({ children }) => {
    /* eslint-disable */
    const [sortableRef, setSortableRef] = (0, react_1.useState)();
    const [dragging, setDragging] = (0, react_1.useState)(false);
    const sortable = (0, react_1.useRef)();
    const myCss = (0, web_css_1.default)(makeMyClasses, [dragging]);
    const handleRef = e => {
        if (e)
            setSortableRef(e.childNodes[0].childNodes[0]);
    };
    const handleDragStart = (0, react_1.useCallback)(() => {
        setDragging(true);
    }, []);
    const handleDragEnd = (0, react_1.useCallback)(e => {
        setDragging(false);
        onReorder(e.oldIndex, e.newIndex);
    }, []);
    (0, react_1.useEffect)(() => {
        if (sortableRef) {
            sortable.current = new sortablejs_1.default(sortableRef, {
                handle: '.dragHandle',
                onStart: handleDragStart,
                onEnd: handleDragEnd,
            });
        }
    }, [sortableRef]);
    return (react_1.default.createElement("div", { ref: handleRef, className: myCss.root + ' MuiTabs-root' }, children));
    /* eslint-enable */
};
